import React, { useEffect } from 'react';
import {
  Box,
  VStack,
  Text,
  Spinner,
  Image,
} from '@chakra-ui/react';

/** Gradiente corporativo (CSS nativo; Chakra v3 no interpreta `linear(to-br, token…)`). */
const CORPORATE_BG =
  'linear-gradient(135deg, #4c1d95 0%, #6d28d9 42%, #7c3aed 70%, #d97706 100%)';

const LoadingScreen = ({ onComplete, duration = 2000, message = 'Iniciando sesión...' }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [onComplete, duration]);

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg={CORPORATE_BG}
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="9999"
    >
      <VStack gap={8} textAlign="center">
        <Box
          animation="pulse 2s infinite"
          css={{
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(1)',
                opacity: 0.9,
              },
              '50%': {
                transform: 'scale(1.05)',
                opacity: 1,
              },
              '100%': {
                transform: 'scale(1)',
                opacity: 0.9,
              },
            },
          }}
        >
          <Image
            src="/logo y texto cadencya blanco.png"
            alt="Cadencya"
            h="100px"
            w="auto"
            filter="drop-shadow(0 8px 16px rgba(0,0,0,0.4))"
          />
        </Box>

        <Text
          color="whiteAlpha.900"
          fontSize="xl"
          fontWeight="600"
          textShadow="1px 1px 2px rgba(0,0,0,0.3)"
        >
          {message}
        </Text>

        <Spinner
          borderWidth="4px"
          animationDuration="0.65s"
          emptyColor="whiteAlpha.300"
          color="white"
          size="xl"
        />
      </VStack>
    </Box>
  );
};

export default LoadingScreen;
